import { Routes, Route } from "react-router-dom";
import { DASHBOARD, NOTIFICATION,PROFILE } from "../constants/routes";
import DashboardScreen from "../screens/DashboardScreen";
import NotificationScreen from "../screens/NotificationScreen";
import ProfileScreen from "../screens/ProfileScreen";

export default function UserRouter() {
  return (
    <Routes>
      <Route path={DASHBOARD} element={<DashboardScreen />} />
      <Route path={NOTIFICATION} element={<NotificationScreen />} />
      <Route path={PROFILE} element={<ProfileScreen />} />
    </Routes>
  );
}
